import { Entity, IEntity } from "./Entity";
import { IUser } from "./User";
import { IDirectorate } from "./Directorate";
import { IOrgLevel1 } from "./OrgLevel1";
import { IOrgLevel3 } from "./OrgLevel3";
import { EntityWithStatus, IEntityWithStatus } from "./EntityWithStatus";
import { IReportingEntity, ReportingEntity } from "./ReportingEntity";
import { IRiskAppIssueAction } from "./RiskAppIssueAction";

export interface IRiskAppIssue extends IReportingEntity {
    IssueCode?: string;
    SourceID?: number;
    StageID?: number;
    PriorityID?: number;
    DateIdentified?: Date | null;
    TargetResolutionDate?: Date | null;
    OwnerTypeID?: number;
    OwnerL0ID?: number;
    OwnerL1ID?: number;
    OwnerL2ID?: number;
    OwnerL3ID?: number;
    ManagedByTypeID?: number;
    ManagedByL2ID?: number;
    ManagedByL3ID?: number;
    RootCauseAnalysis?: string;
    LessonsLearned?: string;
    EntityCreatedOn?: Date | null;
    EntityModifiedOn?: Date | null;
    CustomerID?: number;
    ManagedByL2?: IDirectorate;
    ManagedByL3?: IOrgLevel3;
    OwnerL1?: IOrgLevel1;
    OwnerL2?: IDirectorate;
    OwnerL3?: IOrgLevel3;
    Priority?: IEntity;
    Source?: IEntity;
    Stage?: IEntity;
    IssueManagerID?: number;
    ReportedByID?: number;
    IssueManager?: IUser;
    ReportedBy?: IUser;

    RiskAppIssueActions?: IRiskAppIssueAction[];
}

export class RiskAppIssue extends ReportingEntity implements IRiskAppIssue {
    public IssueCode = null;
    public SourceID = null;
    public StageID = null;
    public PriorityID = null;
    public DateIdentified = null;
    public TargetResolutionDate = null;
    public OwnerTypeID = null;
    public OwnerL0ID = null;
    public OwnerL1ID = null;
    public OwnerL2ID = null;
    public OwnerL3ID = null;
    public ManagedByTypeID = null;
    public ManagedByL2ID = null;
    public ManagedByL3ID = null;
    public RootCauseAnalysis = null;
    public LessonsLearned = null;
    public EntityCreatedOn = null;
    public EntityModifiedOn = null;
    public CustomerID = null;
    public Customer = null;
    public ManagedByL2 = null;
    public ManagedByL3 = null;
    public OwnerL1 = null;
    public OwnerL2 = null;
    public OwnerL3 = null;
    public Priority = null;
    public Source = null;
    public Stage = null;
    public IssueManagerID = null;
    public ReportedByID = null;
    public IssueManager = null;
    public ReportedBy = null;
}
